import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import "./grow.scss";
const Grow = () => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    function handleScroll() {
      setOffset(window.pageYOffset);
    }

    window.addEventListener("scroll", handleScroll);
  });

  return (
    <div className="home-grow">
      <div className="left-side">
        <div className="img1"></div>
        <div
          className="img"
          style={{
            transform: `rotate(${offset * 0.05}deg)  `,
          }}
        ></div>
      </div>
      <div className="right-side">
        <h1 className="big-title">
          <FormattedMessage
            id="Grow"
            defaultMessage="Grow your business"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="We've"
            defaultMessage="We’ve developed a simple onboarding process to help us better understand what your business needs. With our team of specialists we'll work on what needs to be done and help your grow your business."
          />
        </p>
      </div>
    </div>
  );
};

export default Grow;
